namespace RedBullMOBILE360.Web.API {
    export namespace OSNService {
        export const baseUrl = '~/api/OSN';

        export declare function SMS(request: Web.Models.OSNSMS, onSuccess?: (response: Microsoft.AspNetCore.Mvc.IActionResult) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Subscribe(request: Web.Models.OSNSubscriptionRequest, onSuccess?: (response: Microsoft.AspNetCore.Mvc.IActionResult) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            SMS = "~/api/OSN/SMS",
            Subscribe = "~/api/OSN/Subscribe"
        }

        [
            'SMS', 
            'Subscribe'
        ].forEach(x => {
            (<any>OSNService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
